module.exports = "/_next/static/images/OgBilling-c0ae553312ed6b8b9ad809413ed0d934.jpeg";